import React from 'react';
import { styles } from './SimpleBreadcrumbs.css';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import { useBreakpoint } from '@jbhi-fi/lanyard-ui/utils/useBreakpoint';
import { Link } from '../PlatformFunctionality';
import { PossiblyResponsiveValue, useResponsiveValue } from '../hooks/useResponsiveValue';
import { NavCarousel } from '../NavCarousel/NavCarousel';
import { palette } from '@jbhi-fi/lanyard-ui/themes';

const DEFAULT_COLOR = palette.primary.neutral;

export type BreadcrumbItemProps = {
  label: string;
  href?: string;
  isLink?: boolean;
  isLastItemBold?: boolean;
  color?: string;
};

export type SimpleBreadcrumbsProps = {
  breadcrumbs: PossiblyResponsiveValue<Array<BreadcrumbItemProps>>;
  color?: string;
};
export const BreadcrumbItem = ({ label, href, isLink = true, color = DEFAULT_COLOR }: BreadcrumbItemProps) => {
  return href && isLink ? (
    <Link className={styles.text} href={href} style={{ color: color ?? palette.primary.neutral }}>
      {label}
    </Link>
  ) : (
    <p className={styles.text} style={{ color: color ?? palette.primary.neutral }}>
      {label}
    </p>
  );
};
export const SimpleBreadcrumbs = ({ breadcrumbs: breadcrumbsProp, color = DEFAULT_COLOR }: SimpleBreadcrumbsProps) => {
  const breadcrumbs = useResponsiveValue(breadcrumbsProp);
  const isDesktop = useBreakpoint('md', 'up');
  const isSingleItem = breadcrumbs?.length === 1;

  return (
    <NavCarousel
      className={styles.container}
      spaceBetween={isDesktop ? 14 : 10}
      slideClassName={styles.item({ isLastItemBold: !isSingleItem })}
    >
      {breadcrumbs.map((breadcrumb, i) => {
        const isLastItem = i === breadcrumbs?.length - 1;
        return (
          <div className={styles.itemWrapper} key={i} data-testid={`breadcrumb-${i}`}>
            {isSingleItem ? (
              <Icon
                name="ArrowLeft"
                height="11px"
                width="6px"
                className={styles.arrowIcon}
                style={{ color: color ?? DEFAULT_COLOR }}
              />
            ) : null}
            <BreadcrumbItem
              {...breadcrumb}
              isLink={!isLastItem || isSingleItem}
              isLastItemBold={!isSingleItem}
              color={color}
            />
            {!isLastItem ? (
              <Icon
                name="ArrowRight"
                height="11px"
                width="6px"
                className={styles.arrowIcon}
                style={{ color: color ?? DEFAULT_COLOR }}
              />
            ) : null}
          </div>
        );
      })}
    </NavCarousel>
  );
};
